module.exports = __webpack_public_path__ + "static/media/CV - Mateusz Kaproń.b85e2fe7.pdf";